import React from 'react';

const Sales = () => {
    return (
        <div className="page">
            <div className="page-header">
                <h1>Sales</h1>
            </div>
            <div className="card">
                <h2>Sales Dashboard</h2>
                <p style={{ color: 'var(--text-muted)' }}>Coming soon...</p>
            </div>
        </div>
    );
};

export default Sales;